<style scoped>
      .title {
        font-size: 20px;
    }
    .title2 {
        font-size: 14px;
    }
    hr {
        border: 1px solid #f69f00;
        margin: 0 16px 0 16px;
    }
    p {
        padding: 0 16px 0 16px;
    }
</style>

<template>
  <div>
    <v-card>
      <v-list two-line subheader>
        <v-subheader class="title">KONTAKT Z PROJEKTANTEM</v-subheader>
      </v-list>
      <v-subheader class="title2">Magdalena Dziełakowska</v-subheader>
      <p>Zakres pomocy: Projektowanie w PV*Sol oraz ekonomika inwetycji</p>
      <v-subheader class="title2">Piotr Szymański</v-subheader>
      <p>Zakres pomocy: Nadzór nad projektami oraz kontakt z dostawcami energii</p>
      <v-subheader class="title2">Tomasz Tokarski</v-subheader>
      <p>Zakres pomocy: Wykonywanie pomiarów i zdjęć dronem oraz modeli 3d</p>
      
      <hr>
      
      <v-container>
      <v-select  :items="projektant" label="Wybierz projektanta" ></v-select>
      
      <v-text-field label="Temat" v-model="koszt" ></v-text-field>
      <v-textarea label="Treść pytania" type="number" v-model="moc" ></v-textarea>

      <v-btn >Wyślij</v-btn>
      </v-container>
    </v-card>
    <div class="overlay" v-if="!ready">
      <div class="flex-spinner">
        <v-progress-circular :size="200" :width="7" indeterminate color="amber"></v-progress-circular>
      </div> 
    </div>
  </div>
</template>

<script>

import Item from "@/models/Item";

export default {
  mounted () {
    this.$auth.check()
    .then(user => { })
    .catch(err => {
      console.log(err)
    })

    // retrieve messaging token.
    // only for production, you have to register the service-worker.

    // this.$store.state.messaging.getToken()
    //     .then((token) => {
    //         this.token = token
    //     })
  },
  firebase () {
    return {
      data: {
        source: this.$myDatabase.child("Solarspot"),
        readyCallback: () => {
          this.ready = true
        }
      }
    };
  },
  data () {
    return {
      token: "",
      Item: new Item(this.$myDatabase.child('item')).init(),
      ready: false,
      projektant: ['Magdalena Dziełakowska', 'Piotr Szymański', 'Tomasz Tokarski']
      
    }
  },
  methods: {
    addItem () {
      this.$firebaseRefs.data.onDisconnect().cancel()
      this.Item.push()
      this.Item.name = ""
    },
    deleteItem (key) {
      this.Item.remove(key);
    }
  }
};
</script>



// WEBPACK FOOTER //
// App2.vue?c3efb638